import { createContext, useContext } from 'react';
import { IAppCardConfig } from '@orcha/micro-library-core-ui';
import { IMicrositeConfiguration } from 'src/interfaces/microsite';
import { IOrchaPlatformConfig } from '@orcha/types';
import IPackageConfiguration from '@orcha/types/package';

const useSiteController = (
  site?: IMicrositeConfiguration,
  packageConfig?: IPackageConfiguration,
  appCardConfig?: IAppCardConfig,
  siteMode?: string
) => {
  const platformConfig: IOrchaPlatformConfig | undefined =
    packageConfig?.orchaPlatforms.appLibrary;

  return {
    ...site,
    siteName: site?.name,
    ...packageConfig,
    ...platformConfig,
    appCardConfig,
    siteMode,
  };
};

const SiteContext = createContext<ReturnType<typeof useSiteController>>({
  appCardConfig: undefined,
  siteName: undefined,
  siteMode: undefined,
});

export const SiteProvider = ({
  siteData,
  packageConfig,
  appCardConfig,
  siteMode,
  children,
}) => (
  <SiteContext.Provider
    value={useSiteController(siteData, packageConfig, appCardConfig, siteMode)}
  >
    {children}
  </SiteContext.Provider>
);

export const useSiteContext = () => useContext(SiteContext);
